import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Spin} from 'antd'
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'

@inject('reportTagStore')
@observer
class ReportTag extends Component {
  render() {
    const {reportTagStore, location} = this.props
    const {isFetching} = reportTagStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm location={location}/>
          <SearchResult/>
        </div>
      </Spin>
    )
  }
}

export default ReportTag